import script from "./LegalDocumentsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocumentsForm.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocumentsForm.vue?vue&type=style&index=0&id=7b1842f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1842f0"]])

export default __exports__